export enum OrderType {
  Unknown = 0,
  OneTime = 1,
  Installment = 2,
  PayAsYouGo = 3,
}

const ORDER_TYPE_LABELS: Record<OrderType, string> = {
  [OrderType.Unknown]: "Unknown",
  [OrderType.OneTime]: "One Time",
  [OrderType.Installment]: "Installment",
  [OrderType.PayAsYouGo]: "Pay As You Go",
};

export const formatOrderType = (value: number): string =>
  ORDER_TYPE_LABELS[value as OrderType] ?? "Unknown";

export enum OrderTransactionType {
  Unknown = 0,
  Deposit = 1,
  CardAuthorizationInitialization = 2,
  RemainingPayment = 3,
  Payment = 4,
  Arbitrary = 5,
  OneTimePayment = 6,
}

const ORDER_TRANSACTION_TYPE_LABELS: Record<OrderTransactionType, string> = {
  [OrderTransactionType.Unknown]: "Unknown",
  [OrderTransactionType.Deposit]: "Deposit",
  [OrderTransactionType.CardAuthorizationInitialization]: "Card Authorization",
  [OrderTransactionType.RemainingPayment]: "Remaining Payment",
  [OrderTransactionType.Payment]: "Payment",
  [OrderTransactionType.Arbitrary]: "Arbitrary",
  [OrderTransactionType.OneTimePayment]: "One Time Payment",
};

export const formatOrderTransactionType = (value: number): string =>
  ORDER_TRANSACTION_TYPE_LABELS[value as OrderTransactionType] ?? "Unknown";

export enum OrderStatus {
  Unknown = 0,
  Pending = 1,
  DeliveryInProgress = 2,
  InstallationInProgress = 3,
  CustomerVerificationInProgress = 4,
  Final = 5,
  Failed = 6,
  WaitingCreditApproval = 7,
  FailedCreditApproval = 8,
  DeclinedByCustomer = 9,
  CreditApproved = 10,
  DepositNotPaid = 11,
  OutOfStock = 12,
}

const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  [OrderStatus.Unknown]: "Unknown",
  [OrderStatus.Pending]: "Pending",
  [OrderStatus.DeliveryInProgress]: "Delivery In Progress",
  [OrderStatus.InstallationInProgress]: "Installation In Progress",
  [OrderStatus.CustomerVerificationInProgress]: "Customer Verification In Progress",
  [OrderStatus.Final]: "Final",
  [OrderStatus.Failed]: "Failed",
  [OrderStatus.WaitingCreditApproval]: "Waiting Credit Approval",
  [OrderStatus.FailedCreditApproval]: "Failed Credit Approval",
  [OrderStatus.DeclinedByCustomer]: "Declined By Customer",
  [OrderStatus.CreditApproved]: "Credit Approved",
  [OrderStatus.DepositNotPaid]: "Deposit Not Paid",
  [OrderStatus.OutOfStock]: "Out Of Stock",
};

export const formatOrderStatus = (value: number): string =>
  ORDER_STATUS_LABELS[value as OrderStatus] ?? "Unknown";

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  export const formatAmount = (amount: number, currency: string = "NGN"): string => {
    return `${amount.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${currency}`;
  };

export const formatTime = (dateString: string): string => {
      const date = new Date(dateString);
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
};